var exports = {
  "om": "xa15a2ab7--68af15--block",
  "DD": "xa15a2ab7--68af15--title",
  "lt": "xa15a2ab7--68af15--link-wrapper",
  "a_": "xa15a2ab7--68af15--terms",
};

module.exports = exports;
